import { httpClient } from '@/services/http/httpClient'

export type ChangePasswordParams = {
  password: string
  newPassword: string
}

export async function changePassword({
  password,
  newPassword,
}: ChangePasswordParams): Promise<void> {
  await httpClient.post('/users/me/password', {
    oldPassword: password,
    newPassword,
  })
}
